import { useParams } from '@tanstack/react-router'

import { SessionLogWorkScreen } from '@/screens/SessionLogWorkScreen'
import { ServicePageShell } from '@/screens/ServicePageShell'
import { useSessionLogWork } from '@/screens/useSessionLogWork'

export function SessionLogWorkScreenContainer() {
  const sessionId = useParams({
    from: '/sessions/$id/logs',
    select: (p) => p.id,
  })
  const logWork = useSessionLogWork(sessionId)

  if (logWork.kind === 'loading') {
    return (
      <div className="bg-slate-50 text-slate-900">
        <main className="max-w-container mx-auto px-4 py-6 space-y-2">
          <h1 className="text-2xl font-semibold">Session Log Work</h1>
          <p className="text-sm text-slate-600">Loading session…</p>
        </main>
      </div>
    )
  }

  if (logWork.kind === 'error') {
    return (
      <div className="bg-slate-50 text-slate-900">
        <main className="max-w-container mx-auto px-4 py-6 space-y-2">
          <h1 className="text-2xl font-semibold">Session Log Work</h1>
          <p className="text-sm text-slate-600">Unable to load session right now.</p>
        </main>
      </div>
    )
  }

  if (logWork.kind === 'not_found') {
    return (
      <div className="bg-slate-50 text-slate-900">
        <main className="max-w-container mx-auto px-4 py-6 space-y-2">
          <h1 className="text-2xl font-semibold">Session Log Work</h1>
          <p className="text-sm text-slate-600">
            Remote session not found. Check the link or return to the bookings page.
          </p>
        </main>
      </div>
    )
  }

  const displayId = logWork.screenProps.publicId ?? logWork.screenProps.id

  return (
    <ServicePageShell
      serviceTypeLabel={logWork.screenProps.resourceLabel ?? 'TeamViewer Session'}
      serviceId={displayId}
      customerName={logWork.screenProps.customerName}
      customerId={logWork.screenProps.customerId}
      customerPublicId={logWork.screenProps.customerPublicId}
      scheduledAtLabel={logWork.screenProps.scheduledAt}
      initialIssue={logWork.screenProps.issueSummary}
      activeTab="logs"
      basePath="/sessions/$id"
      currentStatus={logWork.screenProps.status}
      statusChanges={logWork.screenProps.statusChanges}
      getAuthorDisplayName={logWork.screenProps.getAuthorDisplayName}
    >
      <SessionLogWorkScreen {...logWork.screenProps} showHeader={false} />
    </ServicePageShell>
  )
}
